//只能输入数字，保留四个小数点
const numberInput = {
  inserted(el) {
    el.addEventListener('input', (e) => {
      e.target.value = e.target.value
        .replace(/[^\d.]/g, '') //只能输入数字
        .replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3') //只能输入4个小数
        .replace(/\.{2,}/g, '.') //出现多个点时只保留第一个
        .replace(/^00*(\d)([0-9]*)/g, '$1$2');// 前两位不能同时是0;"
    });
  }
};


const moneyInput = {
  inserted(el) {
    el.addEventListener('input', (e) => {
      e.target.value = e.target.value
        .replace(/[^\d.]/g, '') //只能输入数字
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入2个小数
        .replace(/\.{2,}/g, '.') //出现多个点时只保留第一个
        .replace(/^00*(\d)([0-9]*)/g, '$1$2');// 前两位不能同时是0;"
    });
  }
};


// 只能输入整数（无小数点）
const integerInput = {
  inserted(el) {
    el.addEventListener('input', (e) => {
      e.target.value = e.target.value
        .replace(/[^\d]/g, '') // 只能输入数字
        .replace(/^0+(\d+)/, '$1'); // 不允许以多个0开头
    });
  }
};
  

// 导出所有指令
export default {
  numberInput,
  moneyInput,
  integerInput
};